<template>
  <div class="main-page page-sw-dynamics">
    <Menu title="涉外服务动态" :home="true" />
    <div class="container-flex dynamics-container">
      <div v-if="loading" class="state">正在加载…</div>
      <div v-else-if="!list.length" class="state">暂无相关数据</div>
      <div v-else class="news-list">
        <button v-for="item in list" :key="item.id" class="news-item" @click="$router.push('/foreign-news/' + item.id)">
          <img v-if="item.img && item.img.length" :src="item.img[0]" alt="">
          <div class="intro">
            <h2>{{ item.title }}</h2>
            <p>{{ plainText(item.desc) }}</p>
            <span>来源：{{ item.source || '云南掌上12348' }}　时间：{{ item.post_time }}</span>
          </div>
        </button>
      </div>
      <el-pagination v-if="totalPages > 1" background layout="prev, pager, next" :page-count="totalPages" :current-page="page" @current-change="loadList" />
    </div>
  </div>
</template>

<script>
import Menu from '@/components/Menu'

export default {
  components: { Menu },
  data () { return { list: [], page: 1, totalPages: 1, loading: false } },
  mounted () { this.loadList(1) },
  methods: {
    async loadList (page) {
      this.page = page
      this.loading = true
      try {
        const data = await this.$api.getCodeNews({ page, category: 6 })
        this.list = data.items || []
        this.totalPages = Number(data.num_pages) || 1
      } catch (error) {
        this.list = []
      } finally {
        this.loading = false
      }
    },
    plainText (value) { return String(value || '').replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').slice(0, 120) }
  }
}
</script>

<style lang="stylus" scoped>
.page-sw-dynamics
  .dynamics-container
    padding 0.2rem 1.2rem 0.5rem
    display flex
    flex-direction column
  .news-list
    flex 1
    overflow-y auto
    border-radius 0.1rem
    background #fff
  .news-item
    display flex
    width 100%
    padding 0.25rem
    text-align left
    border-bottom 1px solid #eee
    img
      width 2.4rem
      height 1.45rem
      margin-right 0.25rem
      object-fit cover
      border-radius 0.06rem
    .intro
      flex 1
      min-width 0
      h2
        font-size 0.26rem
        color #333
      p
        margin 0.16rem 0
        font-size 0.19rem
        color #666
      span
        color #999
        font-size 0.16rem
  .state
    flex 1
    display flex
    align-items center
    justify-content center
    color #fff
    font-size 0.24rem
  .el-pagination
    padding-top 0.2rem
    text-align center
</style>
